/**
 * Import estático (build-time) dos contratos versionados de `contracts/authz/v1/` (TASK-15).
 *
 * Decisão de design: build-time / import estático, não runtime/fetch. Motivos: (1) os três
 * JSONs são arquivos VERSIONADOS no monorepo, na mesma árvore git do código que os consome —
 * fetch em runtime introduziria uma dependência de rede/servidor de estáticos sem necessidade,
 * para dados que já viajam junto no mesmo commit; (2) `tsconfig.base.json` já declara
 * `resolveJsonModule: true` para todo o monorepo, sinal de que o padrão pretendido é import
 * estático de JSON (não havia precedente de uso no portal antes desta task — confirmado por
 * busca em `src/`); (3) o workspace é pnpm (`pnpm-workspace.yaml` na raiz), e o Vite detecta a
 * raiz do workspace automaticamente para `server.fs.allow`, então importar um caminho fora de
 * `apps/web/azim-portal/` funciona sem configuração extra, tanto em `vite build` quanto em
 * `vitest`. Paralelo em C#: `Azim.Authorization` (TASK-14) provavelmente inclui os mesmos JSONs
 * como conteúdo embutido no assembly — aqui o equivalente é o import estático do bundler.
 *
 * Os deltas (`default-profile-deltas/*.json`) são importados um por um, por nome, em vez de via
 * `import.meta.glob`: o projeto não tem `vite-env.d.ts` com `/// <reference types="vite/client" />`,
 * então os tipos de `import.meta.glob` não estariam disponíveis sem adicionar essa referência: e
 * o próprio `contracts/authz/v1/default-profile-deltas/README.md` já mantém à mão uma tabela dos
 * números reservados (0001-0004) — listar os arquivos aqui explicitamente segue o mesmo padrão
 * já estabelecido nesse README, em vez de introduzir um mecanismo novo. Ao criar um delta novo,
 * este arquivo precisa de uma linha nova em `DEFAULT_PROFILE_DELTAS` (mesma disciplina manual que
 * o README já pede para a tabela de números reservados).
 */
import permissionCatalogRaw from "../../../../../../contracts/authz/v1/permission-catalog.json";
import defaultProfilesRaw from "../../../../../../contracts/authz/v1/default-profiles.json";
import delta0001Raw from "../../../../../../contracts/authz/v1/default-profile-deltas/0001-gestor-leitura-basica.json";

import type {
  DefaultProfileDelta,
  DefaultProfilesDocument,
  PermissionCatalogDocument,
} from "./types.js";

export const PERMISSION_CATALOG: PermissionCatalogDocument =
  permissionCatalogRaw as unknown as PermissionCatalogDocument;

export const DEFAULT_PROFILES: DefaultProfilesDocument =
  defaultProfilesRaw as unknown as DefaultProfilesDocument;

/**
 * Deltas conhecidos, na ordem em que aparecem no README (`0001` primeiro). A ordem de
 * APLICAÇÃO real é decidida por `permissionModel.ts` via topological sort de `requires` —
 * esta lista é só o inventário dos arquivos existentes (só `0001` nesta task; `0002`-`0004`
 * seguem reservados, não criados).
 */
export const DEFAULT_PROFILE_DELTAS: readonly DefaultProfileDelta[] = [
  delta0001Raw as unknown as DefaultProfileDelta,
];
